<template>
  <div>
    <div class="container__builderall">
      <div class="container__builderall--boxed">
        <div v-if="teams.length > 0" class="table-responsive">
          <div>
            <table class="table table-team" >
              <thead>
                <th colspan="2"></th>
                <th v-text="t.team_account_team_name"></th>
                <th v-text="t.team_account_team_leader"></th>
                <th v-text="t.team_account_my_commission"></th>
                <th></th>
              </thead>
              <tbody>
                <tr v-for="tp in teams">
                  <td>
                    <span v-if="tp.status == 10" class="builderall-icon icon-active"></span>
                    <span v-else class="builderall-icon icon-error builderall-tooltiped">
                      <span class="builderall-tooltiped__text" v-html="t.account_have_an_error"></span>
                    </span>
                  </td>
                  <td><img class="team-member" :src="tp.img"></td>
                  <td>{{ tp.nome_time | empty}}</td>
                  <td>{{ tp.nome_lider}} <br> <small> {{ tp.email_lider }} </small> </td>
                  <td><h2 class="percentage">{{ tp.percentual | toFixed}}%</h2></td>
                  <td>
                    <a @click="initModalLeave(tp)">  
                      <span class="builderall-icon icon-leave_team"></span> 
                    </a>                
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div 
          v-else 
          class="builderall-block_info" 
          style="margin-top: 0"
          v-html="t.team_account_user_not_belong_team"
          ></div>
      </div>
    </div>

    <div class="modal fade" id="modalLeaveTeam" tabindex="-1" role="dialog" aria-labelledby="modalLeaveTeam" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content builderall-modal">
          <div class="builderall-modal__header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h3 
              class="builderall-modal__header--title"
              v-html="t.team_account_leave_team"
              >
            </h3>
          </div>
          <div class="builderall-modal__body" style="padding: 3rem 3rem 0 4rem">
            <p><b v-html="t.team_account_leave_team_confirmation"></b></p>
            <table class="table table-team" style="margin-top: 1.5rem" >
              <tbody>
                <tr>
                  <td><img class="team-member" :src="teamToLeave.img"></td>
                  <td>{{ teamToLeave.nome }}</td>
                  <td>{{t.team_account_percentage}}: {{ teamToLeave.percentual | toFixed}}%</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="builderall-modal__footer center">
            <button 
              type="submit" 
              :class="['button3 extra-large', {'__loading': leaving}]"
              @click="leaveTeam()">
              {{t.label_wl_yes}}, {{t.team_account_leave_team}}
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>



<script type="text/javascript">
	export default {
	  name: "team-account-member",
	  props: ["teams_participate","handler_routes","t"],

	  data() {
	    return {
	      teams: [],
        isEmptyTeamsParticipate: false,
        teamToLeave: [],
        leaving: false
	    };
	  },

    created(){
      this.teams = this.teams_participate
    },

    methods :{

      initModalLeave(team){
        this.teamToLeave = team;
        //pega todos os modais
        let allModals = document.querySelectorAll('#modalLeaveTeam');
        // //verifica se existe um criado a mais e remove
        if(allModals.length == 2) allModals[0].remove();
        $('#modalLeaveTeam').modal('show');
      },

      leaveTeam() {
        let vm = this;
        vm.leaving = true;
        axios.post(this.handler_routes.member, {
          'action': 'leave',
          'id_office_time': vm.teamToLeave.id_office_time,
          'id_office_time_usuario': vm.teamToLeave.id
        }).then(function (response) {
          if (response.data.status == 'success') {
            vm.teams.splice(vm.teams.indexOf(vm.teamToLeave), 1)
            $('#modalLeaveTeam').modal('hide');
            alertMsg('success', response.data.message)
          }
          else{
            alertMsg('error', response.data.message)
          }
        })
        .catch(function (error) {
          alertMsg('error', error)
        })
        .finally(function() {
          vm.leaving = false;
        })
      }
    },
    filters:{
      toFixed(value){
        return (value * 100).toFixed()
      },
      empty(value){
        return value == '' ? ' - ' : value
      }
    }
	}
</script>

<style lang="scss">
@import '../../../scss/team-account/style.scss';
.table-team small{
  color: #cccccc;
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/team-account/member.vue